import { useInfiniteQuery } from "@tanstack/react-query";
import type { DashboardNewsPage } from "@arc/contracts";
import type { AuthSession } from "../../auth/keycloak.js";
import { dashboardApi } from "../../api/client.js";

export const NEWS_PAGE_SIZE = 50;

/**
 * `GET /dashboard/news` (ADR-034 D4): the History feed, keyset-paginated — "Load more" appends the next page; the
 * cursor is the server's opaque `nextCursor`. Same freshness as the overview (a minute, refetched on focus).
 */
export function useDashboardNews(session: AuthSession | null) {
  return useInfiniteQuery<DashboardNewsPage, Error, { pages: DashboardNewsPage[] }, readonly unknown[], string | undefined>({
    queryKey: ["dashboard-news", session?.realm, session?.sub],
    enabled: session !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    initialPageParam: undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    queryFn: async ({ pageParam }) => {
      const res = await dashboardApi.getNews({ query: { limit: NEWS_PAGE_SIZE, ...(pageParam ? { before: pageParam } : {}) } });
      if (res.status !== 200) throw new Error(`GET /dashboard/news returned ${res.status}`);
      return res.body;
    },
  });
}
